import React, { Fragment, useEffect } from "react";
import { withRouter } from "react-router";
import { injectIntl, intlShape } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
import { Button } from "cxa-components";
import messages from "components/messagesDescription";
import PropTypes from "prop-types";
import { getDashboardActions } from "actions/dashboardActionsPP";

const SuccessPage = props => {
  const { intl, push } = props;

  const claimItem = useSelector(state => state.claimsPP.claimItem);
  const claimDetail = useSelector(state => state.claimsPP.claimDetail);

  const submitAnotherClaim = () => {
    push(`/claims/submit`);
  };
  const trackMyClaims = () => {
    push(`/claims/track`);
  };

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getDashboardActions());
    //Scroll to the top of the page
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    claimItem &&
    claimDetail && (
      <Fragment>
        <div className="success-page-container">
          <img src="/assets/images/svg/claim_success.svg" alt="" style={{ width: "180px" }} />
          <h5>
            <strong>
              {intl
                .formatMessage(messages.claims.claimSuccessfulMessage)
                .replace("##id##", claimDetail.id)}
            </strong>
          </h5>
          <br />
          <p
            style={{ textAlign: "left" }}
            dangerouslySetInnerHTML={{
              __html: intl.formatMessage({
                id: claimItem.claimInstruction,
                defaultMessage: claimItem.claimInstruction,
              }),
            }}
          />
          <br />
          <p style={{ textAlign: "left" }}>
            {intl.formatMessage(messages.claims.claimSuccessfulInstruction)}{" "}
          </p>
          <br />
        </div>
        <div className="claim-submit-button-container submit-claim-margin">
          <Button type="button" secondary onClick={submitAnotherClaim}>
            {intl.formatMessage(messages.claims.submitAnotherClaim)}
          </Button>
          <Button primary type="button" onClick={trackMyClaims}>
            {intl.formatMessage(messages.claims.trackMyClaim)}
          </Button>
        </div>
      </Fragment>
    )
  );
};

SuccessPage.propTypes = {
  intl: intlShape.isRequired,
  push: PropTypes.func,
};
export default withRouter(injectIntl(SuccessPage));



// WEBPACK FOOTER //
// ./components/claim/SuccessPage.js